module.exports = __webpack_public_path__ + "static/media/kw.b8c53b21.png";